import Clubs from '../assets/icons/clubs.png';
import Diamonds from '../assets/icons/diamonds.png';
import Hearts from '../assets/icons/hearts.png';
import Spades from '../assets/icons/spades.png';

export const cards = [
  {
    value: 'A',
    suite: 'clubs',
    suiteIcon: Clubs,
    color: 'black',
    desc: 'Ace of Clubs'
  },
  {
    value: 'A',
    suite: 'diamonds',
    suiteIcon: Diamonds,
    color: 'red',
    desc: 'Ace of Diamonds'
  },
  {
    value: '2',
    suite: 'hearts',
    suiteIcon: Hearts,
    color: 'red',
    desc: '2 of Hearts'
  },
  {
    value: '2',
    suite: 'spades',
    suiteIcon: Spades,
    color: 'black',
    desc: '2 of Spades'
  },
  {
    value: '3',
    suite: 'clubs',
    suiteIcon: Clubs,
    color: 'black',
    desc: '3 of Clubs'
  },
  {
    value: '3',
    suite: 'diamonds',
    suiteIcon: Diamonds,
    color: 'red',
    desc: '3 of Diamonds'
  },
  {
    value: '4',
    suite: 'hearts',
    suiteIcon: Hearts,
    color: 'red',
    desc: '4 of Hearts'
  },
  {
    value: '4',
    suite: 'spades',
    suiteIcon: Spades,
    color: 'black',
    desc: '4 of Spades'
  },
  {
    value: '7',
    suite: 'clubs',
    suiteIcon: Clubs,
    color: 'black',
    desc: '7 of Clubs'
  },
  {
    value: '7',
    suite: 'diamonds',
    suiteIcon: Diamonds,
    color: 'red',
    desc: '7 of Diamonds'
  },
  {
    value: '8',
    suite: 'spades',
    suiteIcon: Spades,
    color: 'black',
    desc: '8 of Spades'
  }, 
  {
    value: '8',
    suite: 'hearts',
    suiteIcon: Hearts,
    color: 'red',
    desc: '8 of Hearts'
  },
  {
    value: '9',
    suite: 'clubs',
    suiteIcon: Clubs,
    color: 'black',
    desc: '9 of Clubs'
  },
  {
    value: '9',
    suite: 'diamonds',
    suiteIcon: Diamonds,
    color: 'red',
    desc: '9 of Diamonds'
  },
  {
    value: '10',
    suite: 'spades',
    suiteIcon: Spades,
    color: 'black',
    desc: '10 of Spades'
  },
  {
    value: '10',
    suite: 'hearts',
    suiteIcon: Hearts,
    color: 'red',
    desc: '10 of Hearts'
  },
  {
    value: 'J',
    suite: 'clubs',
    suiteIcon: Clubs,
    color: 'black',
    desc: 'Jack of Clubs'
  },
  {
    value: 'J',
    suite: 'diamonds',
    suiteIcon: Diamonds,
    color: 'red',
    desc: 'Jack of Diamonds'
  },
  {
    value: 'Q',
    suite: 'spades',
    suiteIcon: Spades,
    color: 'black',
    desc: 'Queen of Spades'
  },
  {
    value: 'Q',
    suite: 'hearts',
    suiteIcon: Hearts,
    color: 'red',
    desc: 'Queen of Hearts'
  },
  {
    value: 'K',
    suite: 'diamonds',
    suiteIcon: Diamonds,
    color: 'red',
    desc: 'King of Diamonds'
  }
];